import React from 'react';
import PropTypes from 'prop-types';

const ActivityTagInput = ({ legend, tagOptions, trainerOption }) => {
  return (
    <fieldset className="activity-tags-input">
      <legend>{legend}</legend>
      <input type="hidden" name="activity[tags][]" value="" />
      <div className="inline-inputs marginless">
        {tagOptions.map((tag) => {
          return (
            <div
              key={tag.key}
              className="input-field"
              data-tag-sports={tag.sportTypes.join(',')}
            >
              <input
                type="checkbox"
                name="activity[tags][]"
                value={tag.gqlString}
                defaultChecked={tag.selected}
                id={tag.key}
              />
              <label htmlFor={tag.key}>
                <span className="tag-label">{tag.label}</span>
                <div className="hole" />
              </label>
            </div>
          );
        })}
        {trainerOption && (
          <>
            <input type="hidden" name="activity[trainer]" value="0" />
            <div
              className="input-field trainer_tag"
              data-tag-sports={trainerOption.sportTypes.join(',')}
              data-label-run={trainerOption.labels.Run}
              data-label-ride={trainerOption.labels.Ride}
              data-label-swim={trainerOption.labels.Swim}
            >
              <input
                type="checkbox"
                name="activity[trainer]"
                value="1"
                defaultChecked={trainerOption.selected}
                id="trainer"
              />
              <label htmlFor="trainer">
                <span className="tag-label trainer-label">{trainerOption.initialLabel || trainerOption.labels.Ride}</span>
                <div className="hole" />
              </label>
            </div>
          </>
        )}
      </div>
    </fieldset>
  );
};

ActivityTagInput.propTypes = {
  legend: PropTypes.string,
  tagOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      key: PropTypes.string.isRequired,
      gqlString: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
      sportTypes: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  ),
  trainerOption: PropTypes.shape({
    selected: PropTypes.bool.isRequired,
    labels: PropTypes.shape({
      Ride: PropTypes.string.isRequired,
      Run: PropTypes.string.isRequired,
      Swim: PropTypes.string.isRequired
    }).isRequired,
    initialLabel: PropTypes.string,
    sportTypes: PropTypes.arrayOf(PropTypes.string).isRequired
  })
};

export default ActivityTagInput;
